import type {
    PropertyGroup,
    PropertyGroupsResponse,
    UpdatePropertyGroupBody,
} from '@thinkalpha/trading-ws-client/contracts/oms/properties.js';
import type { AccountSourcedPropertiesResponse } from 'src/admin/models/Risk';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const tradingApi = createInstance({ baseURL: appConfig.tradingApi });

/**@deprecated use account grid properties for account-level risk properties and settings */
// GET /accounts/{accountId}/oms-settings
export const getAccountOmsSettings = async (accountId: string): Promise<PropertyGroup> => {
    const { data } = await tradingApi.get<PropertyGroup>(`/accounts/${accountId}/oms-settings`);
    return data;
};

export const getAccountRiskPropertiesGrid = async (accountId: string): Promise<AccountSourcedPropertiesResponse> => {
    const { data } = await tradingApi.get<AccountSourcedPropertiesResponse>(`/accounts/${accountId}/property-grid`);
    return data;
};

// PATCH /accounts/{accountId}/oms-settings
export const patchAccountOmsSettings = async (
    accountId: string,
    omsSettings: UpdatePropertyGroupBody,
): Promise<PropertyGroup[]> => {
    const { data } = await tradingApi.patch<PropertyGroupsResponse>(`/accounts/${accountId}/oms-settings`, omsSettings);
    return data.propertyGroups;
};

export const getAccountExecutorVersion = async (accountId: string): Promise<number> => {
    const { data } = await tradingApi.get<{ version: number }>('/orders/executor-version', {
        params: {
            account: accountId,
        },
    });
    return data.version;
};
